import _memoize from 'lodash/memoize'; /* stylelint-disable property-no-vendor-prefix */

import { css } from '@sitebase/emotion';
import { radiusDefaultSize, colorMonochromeWhite, colorPrimary100, colorPrimary50, colorGreen500, colorRed500, fontDefaults, animationDuration } from '../settings';

export var base = /*#__PURE__*/css(fontDefaults, ';background-color:', colorMonochromeWhite, ';border-radius:', radiusDefaultSize, ';box-sizing:border-box;display:flex;font-size:12px;height:100%;position:relative;width:100%;input[type=\'email\'],input[type=\'password\'],input[type=\'text\'],input{', fontDefaults, ';background:transparent;border:none;box-shadow:none;color:inherit;flex-grow:1;font-size:inherit;font-weight:inherit;outline:none;padding:0 0 0 16px;width:100%;line-height:-moz-block-height;align-self:center;&::-ms-clear{display:none;}&::placeholder{color:', colorPrimary100, ';line-height:inherit;font-family:inherit;}&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:active,&:-webkit-autofill:focus{-webkit-box-shadow:0 0 0 9999px #fff inset;}}&::after{background-color:', colorPrimary100, ';border-radius:0 0 ', radiusDefaultSize, ' ', radiusDefaultSize, ';bottom:-1px;content:\'\';display:block;height:3px;position:absolute;left:-1px;transition:width ', animationDuration, ',background-color ', animationDuration, ';width:0%;will-change:width,background-color;}&:disabled{cursor:not-allowed;}');

export var disabled = /*#__PURE__*/css('opacity:0.35;');

export var hidden = /*#__PURE__*/css('display:none;');

var _ref = 'align-items:center;align-self:center;display:flex;flex:0 0 auto;font-size:inherit;height:24px;justify-content:center;transform-origin:right;will-change:margin-right,width,opacity;transition:all ';
var _ref2 = ';width:';
var _ref3 = ';opacity:';
var _ref4 = ';overflow:hidden;margin-right:';
var _ref5 = ';&:nth-child(2){margin-left:';
var _ref6 = ';}';
export var icon = _memoize(function (shown) {
  return (/*#__PURE__*/css(_ref, animationDuration, _ref2, shown ? '24px' : '0', _ref3, shown ? '1' : '0', _ref4, shown ? '8px' : '0', _ref5, shown ? '8px' : '0', _ref6)
  );
});

export var light = /*#__PURE__*/css('border:1px solid ', colorPrimary50, ';');

export var dark = /*#__PURE__*/css('border:none;overflow:hidden;&::after{bottom:0;}');

export var focused = {
  dark: /*#__PURE__*/css('box-shadow:0 1px 2px 1px black,0 2px 10px 7px rgba(150,163,196,0.4);&::after{width:calc(100% + 2px);}'),
  light: /*#__PURE__*/css('box-shadow:0 2px 8px 0 rgba(22,39,81,0.2);border:1px solid ', colorPrimary100, ';&::after{width:calc(100% + 2px);}')
};

export var statuses = {
  initial: /*#__PURE__*/css('&::after{background-color:', colorPrimary100, ';}'),
  error: /*#__PURE__*/css('&::after{width:calc(100% + 2px);background-color:', colorRed500, ';}'),
  success: /*#__PURE__*/css('&::after{width:calc(100% + 2px);background-color:', colorGreen500, ';}')
};

export var errorIcon = /*#__PURE__*/css('color:', colorRed500, ';');

export var successIcon = /*#__PURE__*/css('color:', colorGreen500, ';');

export var sizes = {
  tiny: /*#__PURE__*/css('font-size:10px !important;height:28px !important;'),
  small: /*#__PURE__*/css('font-size:10px !important;height:28px !important;'),
  normal: /*#__PURE__*/css('height:36px !important;'),
  base: /*#__PURE__*/css('height:40px !important;'),
  large: /*#__PURE__*/css('height:46px !important;'),
  'x-large': /*#__PURE__*/css('height:56px !important;'),
  stretched: /*#__PURE__*/css('height:100% !important;')
};

var getTopValue = function getTopValue(shrunk, size) {
  if (!shrunk) return '0';
  switch (size) {
    case 'large':
      return '6px';
    case 'x-large':
      return '11px';
    default:
      return '7%';
  }
};

var _ref7 = ';bottom:0;box-sizing:border-box;color:';
var _ref8 = ';display:flex;flex-direction:column;font-size:\'9px\';transform:scale(';
var _ref9 = ');transform-origin:left;height:';
var _ref10 = ';justify-content:center;left:0;margin-left:16px;pointer-events:none;position:absolute;top:';
var _ref11 = ';transition:all ';
var _ref12 = ';';
export var label = function label(shrunk, size) {
  return (/*#__PURE__*/css(fontDefaults, _ref7, colorPrimary100, _ref8, shrunk ? '0.75' : '1', _ref9, shrunk ? '30%' : '100%', _ref10, getTopValue(shrunk, size), _ref11, animationDuration, _ref12)
  );
};

export var container = /*#__PURE__*/css('display:flex;flex-direction:column;flex-grow:1;position:relative;');

var getTopMarginValue = function getTopMarginValue(shrunk, size) {
  if (!shrunk) return '0';
  switch (size) {
    case 'large':
      return '15px';
    case 'x-large':
      return '20px';
    default:
      return '9px';
  }
};

var _ref13 = 'display:flex;flex-grow:1;margin-top:';
var _ref14 = ';';
export var inputContainer = function inputContainer(shrunk, size) {
  return (/*#__PURE__*/css(_ref13, getTopMarginValue(shrunk, size), _ref14)
  );
};